export const locale = {
    lang: 'ar',
    data: {
        STUDIO_PROJECTS_NEW_PARENT_CREATE: 'إضافة مشروع',
        STUDIO_PROJECTS_NEW_PARENT_GENERAL: 'عموميات',
        STUDIO_PROJECTS_NEW_PARENT_PROJECT_STRUCTURE: 'هيكل المشروع',
        STUDIO_PROJECTS_NEW_PARENT_MEMBERS: 'الأعضاء',
    }
};
